/** Vertical Space with multipliers of 8px */
const Space = ({ size }: { size?: number }) => {
  return <div style={{ height: `${size ? size * 8 : 4}px` }}></div>;
};

export default Space;
